/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';
@use '../../../../mixins';

#vitalparameter-area {
  .vital-param-wireframe {
    @include mixins.page-grid-basics;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
      '. . . .'
      '. . . .';
    row-gap: 0;
  }

  .qsofa-score {
    margin-top: variables.$margin-large;
  }

  .center-slash {
    position: relative;
    top: -40px;
    text-align: end;
    right: -14px;
    z-index: 0;
  }

  .MuiInputBase-root {
    z-index: 1;
  }
  .textfield-select-group {
    width: 100%;
  }
  .additional-info {
    width: 100%;
    .row {
      padding-left: 12px;
      justify-content: space-between;
      > label {
        width: 50%;
        min-width: 160px;
      }
    }
  }

  .MuiButtonGroup-vertical {
    height: 56px;
    button {
      height: 50%;
    }
  }
}

.vitalparameter-title-content {
  display: flex;
  gap: variables.$margin-large;
  align-items: center;
  padding: variables.$padding-medium;
  border-radius: 6px 6px 0 0;

  &.warning {
    background: variables.$color-corpuls-system-yellow-reduced;
  }

  .warning-message-content {
    display: flex;
    align-items: center;
    gap: 8px;
    .warning-message-icon {
      font-size: 1rem;
      color: variables.$color-corpuls-system-yellow;
    }
    .warning-message-description {
      color: variables.$text-color-black-medium-emphasis;
    }
  }

  .data-import-button {
    margin-left: auto;
  }
}
